import styled from "styled-components";
import { Col } from "../Col";

export const FormControlRoot = styled(Col)`
    justify-self: stretch;
    align-self: stretch;
`;
